<template>

  <div id="page-user-list" v-show="loaded">
    
    <!-- Header -->
    <div class="flex justify-between flex-wrap items-center mb-8">

      <!-- Search Form -->
      <!-- <vs-input class="sm:mr-4 mr-0 sm:w-5/5 w-full sm:order-normal order-3 sm:mt-0 mt-4" type="search" v-model="searchItem" placeholder="Search some theory..." /> -->
      <h2 class="font-semibold">List Of Bank</h2>

      <vs-button color="primary" icon-pack="feather" icon="icon-plus" class="mr-4" @click="addItem">Add Bank</vs-button>

    </div>

    <div class="vx-row mt-24" v-show="itemsData.length == 0">
      <div class="vx-col w-full">
        <img
          class="block m-auto mb-base"
          :src="emptyDataImg"
          alt=""
          width="180"
          height="180"
        />
        <h4 class="text-2xl font-light text-center">Empty Bank</h4>
      </div>
    </div>

    <!-- List Of Data -->
    <div class="bank">
      <div class="mt-5">
        <div class="mt-3 mb-3">
        <div class="grid grid-cols-4 gap-4">
          <vx-card class="text-center" v-for="(bank, i) in itemsData" :key="i">
            <img :src="$storagePath + bank.logo" alt="" class="mx-auto px-5 py-3" width="100%" height="100%">
            <h5 class="mt-2 font-semibold">{{ bank.name }}</h5>
            <vs-button 
              type="border" 
              class="mt-5" 
              @click="$router.push({ path: `bank-account/detail/${bank.id}` })"
              >GET INFO</vs-button>
          </vx-card>
        </div>
        </div>
      </div>
    </div>

    <!-- Popup Detail -->
    <vs-popup
      classContent="popup-example"
      title="Detail Bank"
      :active.sync="popupDetail"
      v-if="item"
    >
        <div class="">
          <h1 class="text-lg font-semibold mb-2">
            Name
          </h1>
          <span class="block">
            {{ item.name }}
          </span>
        </div>
    </vs-popup>

     <!--  Popup Form  -->
    <vs-popup classContent="popup-example" :title="`${mode} item`" :active.sync="popup">

      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full">
          <vs-input class="w-full mb-3" :label="$i18n.t('Name')" v-model="form.name" />
        </div>
        <div class="vx-col md:w-1/1 w-full">
          <label class="text-sm opacity-75">Logo</label>
          <div class="flex items-start flex-col sm:flex-row">
              <img :src="url" class="rounded mr-4" width="180" height="180" />
              <div>
                <input type="file" @change="addLogo" class="hidden" ref="update_logo_input" accept="image/*">
                <vs-button  @click="$refs.update_logo_input.click()" class="mr-4 mb-2" type="filled" icon-pack="feather" icon="icon-edit"></vs-button>
                <vs-button @click="removeLogo()" type="border" color="danger" icon-pack="feather" icon="icon-trash"></vs-button>
              </div>
            </div>
        </div>
      </div>

      <div class="mt-5">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click="storeItem">
          {{ $i18n.t('Save') }}
        </vs-button>
      </div>

    </vs-popup>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import moment from "moment";
import axios from '@/axios.js';
// import axios from 'axios';

// Cell Renderer
import CellRendererActions from './cell-renderer/CellRendererActions.vue'

import emptyDataImg from "@/assets/images/pages/search_files.svg";

export default {
  components: {
    vSelect,

    // Cell Renderer
    CellRendererActions,
  },
  data () {
    return {
      loaded: false,
      searchQuery: '',
      form: {},
      url: null,
      popup: false,
      popupDetail: false,
      mode: 'add',
      itemSelected: false,
      item: {},
      moment: moment,
      itemsData: [],
      emptyDataImg: emptyDataImg,
    }
  },
  computed: {
    
  },
  methods: {
    addLogo (e) {
      const file = e.target.files[0]
      this.url = URL.createObjectURL(file)
      this.form.logo = file
    },

    removeLogo () {
      this.url = null
      this.form.logo = null
    },
    getData () {
      axios.get('/api/v1/bank').then(res => {
        this.itemsData = res.data.data
        this.loaded = true;
        this.$vs.loading.close()
      }
      ).catch(err => {
        this.$vs.loading.close()
        this.$vs.notify({
          title:'Opps something error',
          text: err.data.message,
          color:'danger'
        })
      })
    },
    showItem (item) {
       axios.get('/api/v1/bank/' + item.id)
      .then(({data: res}) => {
        this.popupDetail = true
        this.item = res.data
      })
      .catch(err => console.error(err))
    },
    addItem () {
      this.popup = true;
      this.mode = 'add';
    },
    editItem (item) {
      this.popup = true;
      this.mode = 'edit';
      this.itemSelected = item;

      this.form = {
        name: item.name,
      };
    },
    storeItem () {
      if (this.mode == 'add') {

        const formData = new FormData()
        formData.set('name', this.form.name)
        formData.append('logo', this.form.logo)

        axios.post('/api/v1/bank', formData).then(res => {
          this.popup = false;
          this.$vs.notify({
            color: 'success',
            title: 'Successful',
            text: res.data.message
          })
          this.getData();
        }).catch(err => {
          this.popup = false;
          this.$vs.notify({
            title:'Opps something error',
            text: err.data.message,
            color:'danger'
          })
        })
      }
      else if (this.mode == 'edit') {
        let body = {
          name: this.form.name,
          _method: 'PUT',
        };

        axios.post('/api/v1/bank/' + this.itemSelected.id, body).then(res => {
          this.popup = false;

          this.$vs.notify({
            color: 'success',
            title: 'Successful',
            text: res.data.message
          })
          this.getData();
        }).catch(err => {
          this.popup = false;
          this.$vs.notify({
            title:'Opps something error',
            text: err.data.message,
            color:'danger'
          })
        })
      }

      this.mode = false;
    },
    deleteItem (item) {
      axios.delete('/api/v1/bank/' + item.id).then(res => {
        this.$vs.notify({
            color: 'success',
            title: 'Successful',
            text: res.data.msg_status
          })
        this.getData();
      }).catch(err => {
        this.$vs.notify({
          title:'Opps something error',
          text: err.data.msg_status,
          color:'danger'
        })
      })
    },
  },
  mounted () {
    
  },
  watch: {
    $route () {
      this.getData();
    },
    popup () {
      if (!this.popup) {
        this.form = {};
        this.url = null;
      }
    }
  },
  created () {
    this.getData();
    this.$vs.loading({
      text: `Wait a minute, It's getting data.`,
    })
  }
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>